export default __webpack_public_path__ + "static/media/paulynhasaless.ff182373.jpg";